export const COMPANY_NAME_MAX_LENGTH = 160;
export const COMPANY_COMMERCIAL_NAME_MAX_LENGTH = COMPANY_NAME_MAX_LENGTH;
export const CUSTOM_PROPERTY_TEXT_VALUE_MAX_LENGTH = 250;

// Must be kept sync with dotfile core one
export const REJECTED_ANALYSIS_DOCUMENT_PROCESSING_DELAY_IN_MINUTES = 15;
